module.exports = "/images/hub-preview-desktop.png?f4867fed8b8ba68672d7bea02ae3a151";